// Add your custom JS here.
(function ($) {
    // AOS.init();

    // HEADER SCROLL FUNCTIONS
    $(document).scroll(function () {
        if ($(this).scrollTop() > 50) {
            $("#wrapper-navbar").addClass("off-top");
        }
        if ($(this).scrollTop() < 50) {
            $("#wrapper-navbar").removeClass("off-top");
            $(".menu a").removeClass("active");
        }
    });

    var lastScrollTop = 0;
    $(window).scroll(function (event) {
        var st = $(this).scrollTop();
        if (st > lastScrollTop) {
            $("#wrapper-navbar").addClass("hide");
        } else {
            $("#wrapper-navbar").removeClass("hide");
        }
        lastScrollTop = st;
    });



    // HEADER MENU TOGGLE
    $(".menu-toggle").on("click", function () {
        $("#wrapper-menu, .drop").addClass("active");
    });

    $("#wrapper-menu .close, .drop").on("click", function () {
        $("#wrapper-menu, .drop").removeClass("active");
    });




    // SINGLE PRODUCT TOGGLES
    $(".info-tab .toggle").on("click", function () {

        if (!$(this).hasClass("active")) {
            $(this).addClass("active");
            $(this).siblings().slideDown(300);
            $(this).parent().siblings().children(".active").removeClass("active").siblings().slideUp(300);
        } else {
            $(this).removeClass("active");
            $(this).siblings().slideUp(300);
        }
    });



    // SMOOOTH SCROLLING
    $('a[href*="#"]').on("click", function (e) {
        // Check if the anchor link is for the current page
        if (this.pathname === window.location.pathname && this.hash) {
            e.preventDefault(); // Prevent default anchor behavior

            var target = $(this.hash);
            if (target.length) {
                // Disable smooth scrolling temporarily
                $("html").css("scroll-behavior", "auto");

                // Scroll to the target element
                $("html, body").animate(
                    {
                        scrollTop: target.offset().top,
                    },
                    1000,
                    function () {
                        // Re-enable smooth scrolling after scrolling is complete
                        $("html").css("scroll-behavior", "smooth");
                    }
                );
            }
        }
    });


})(jQuery);
